import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SectionCard from '../../components/ui/SectionCard';
import TeamCrest from '../../components/ui/TeamCrest';
import tokens from '../../theme/tokens';

function Confronto({ horario, time1, time2, goleiro1, goleiro2 }) {
  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ p: 1.5, borderRadius: 2, bgcolor: 'background.default' }}>
      <Typography sx={{ fontFamily: tokens.font.display, fontWeight: 700, fontSize: '1.3rem', color: tokens.color.brand, minWidth: 56 }}>{horario}</Typography>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
        <TeamCrest name={time1} size={32} />
        <Typography variant="body2" fontWeight={600} noWrap>{time1}</Typography>
      </Stack>
      <Typography color="text.disabled" fontWeight={700}>×</Typography>
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" fontWeight={600} noWrap>{time2}</Typography>
        <TeamCrest name={time2} size={32} />
      </Stack>
      {(goleiro1 || goleiro2) && (
        <Box sx={{ display: { xs: 'none', sm: 'block' }, minWidth: 120, textAlign: 'right' }}>
          <Typography variant="caption" color="text.secondary">GK {goleiro1} × {goleiro2}</Typography>
        </Box>
      )}
    </Stack>
  );
}

// Componente para representar um grupo de confrontos
function Grupo({ nomeGrupo, confrontos }) {
  const ordenados = [...confrontos].sort((a, b) => a.horario.localeCompare(b.horario));
  return (
    <SectionCard title={nomeGrupo} sx={{ height: '100%' }}>
      <Stack spacing={1}>
        {ordenados.map((confronto, index) => (
          <Confronto key={index} {...confronto} />
        ))}
      </Stack>
    </SectionCard>
  );
}

export default Grupo;
